/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button } from "../../../components";
import { toast } from "react-toastify";
import { AssociateBookingSelectSlot } from "./AssociateBookingSelectSlot";
import { AssociateBookingCustomerDetails } from "./AssociateBookingCustomerDetails";
import { messages } from "../../../utilities/Messages";

const getMessage = messages.associateBooking;

const CreateAssociateBooking = () => {
  const { SelectedFacility } = useAppSelector((state) => state.facilityList);
  const [currentStep, setCurrentStep] = useState(0);
  const [associateBookingData, setAssociateBookingData] = useState({
    facilityId: SelectedFacility ? SelectedFacility : "",
    sportId: "",
    startDate: "",
    endDate: "",
    selectedSlots: [
      {
        bookingDay: "Monday",
        startTime: "09:00",
        endTime: "09:30",
      },
    ],
    phone: "",
    firstName: "",
    lastName: "",
    companyName: "",
    gender: "",
    gstNumber: "",
    email: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    country: "India",
    pincode: "",
    landmark: "",
    latitude: null,
    longitude: null,
    isIgstTax: "false",
    panNumber: "",
    tanNumber: "",
  });
  const [amount, setAmount] = useState({}) as any;

  useEffect(() => {
    setAssociateBookingData({
      ...associateBookingData,
      facilityId: SelectedFacility || "",
      sportId: "",
      startDate: "",
      endDate: "",
      selectedSlots: [],
    });
    if (SelectedFacility === "") {
      toast.error(getMessage.facility_select);
    }
  }, [SelectedFacility]);

  const handleBack = () => {
    setCurrentStep((_oldVal) => {
      if (_oldVal > 0) {
        return --_oldVal;
      } else {
        return _oldVal;
      }
    });
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            {currentStep !== 0 && (
              <>
                <Row>
                  <Col className="text-start">
                    <Button
                      type="button"
                      bname="Back"
                      name="back"
                      id="back"
                      className="btn btn-primary rounded-1 me-3"
                      onClick={handleBack}
                    ></Button>
                  </Col>
                </Row>
                <hr />
              </>
            )}
            {currentStep === 0 && (
              <AssociateBookingSelectSlot
                associateBookingData={associateBookingData}
                setAssociateBookingData={setAssociateBookingData}
                setCurrentStep={setCurrentStep}
                setAmount={setAmount}
              />
            )}
            {currentStep === 1 && (
              <AssociateBookingCustomerDetails
                associateBookingData={associateBookingData}
                setAssociateBookingData={setAssociateBookingData}
                amount={amount}
              />
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};
export { CreateAssociateBooking };
